import { NgInterceptor } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { SecurityRetryService } from "@app/services/security-retry.service";
import { IRootScope } from "@models";
import { events } from "@tools";


export class ForbiddenReason {
    public static SsoNoGroups: string = "SsoNoGroups";
    public static InsufficientPermissions: string = "InsufficientPermissions";
}

@NgInterceptor({
    token: Token.SecurityInterceptor,
    dependencies: [
        Token.$Injector,
        Token.SecurityRetryService,
        Token.$RootScope,
        Token.$Q,
    ]
})
export class SecurityInterceptor {
    constructor(
        private $injector: ng.auto.IInjectorService,
        private securityRetryQueue: SecurityRetryService,
        private $rootScope: IRootScope,
        private $q: ng.IQService
    ) {

        return {
                request: (request: ng.IRequestConfig) => {
                    if ($rootScope.isSfdcCpq) {
                        request.headers["kb-context"] = "sfdccpq"
                    }
                    return request;
                },
                response: (response: ng.IHttpPromiseCallbackArg<any>) => {
                    return response;
                },
                responseError: (response: ng.IHttpResponse<any>) => {
                    let config = (response.config) as any;
                    if (!config.ignoreSecurity) {
                        let $http: ng.IHttpService = $injector.get("$http");
                        let promise;
                        if (response.status === 401) {
                            // if a request set the config to ignore auth, then we don't add the item for replay
                            if (!response.config.doNotReplay) {
                                promise = securityRetryQueue.pushRetryFn("unauthorized-server",
                                    () => $http(response.config));
                            }

                            $rootScope.user = null;
                            $rootScope.$broadcast(events.loginRequested);
                            if (promise) {
                                return promise;
                            }
                        }
                        if (response.status === 403) {
                            if (response.data == ForbiddenReason.SsoNoGroups) {
                                alert("We could not find proper permissions for this user. Please contact your system administrator for assistance.");
                                $rootScope.$broadcast(events.loginRequested);
                            }
                            else {
                                $rootScope.$broadcast(events.permissionDenied);
                            }
                        }
                    }
                    return $q.reject(response);
                }
            } as any;
        }
    }
